<template>
    <div id="trackService">
        <p class="serviceTitle"><span>跟踪服务</span></p>
        <div id="trackContainer">
            <ul id="trackWrapper">
                <li @mouseenter="activityTrack(0)" :class="[{activit : activit == 0},{activityBlock: blk == 0}]">
                    <div class="coverBox ">
                        <div>
                            <img src="../../../assets/imgs/service/cov1.png">
                            <p>主动服务</p>
                        </div>
                    </div>
                    <div class="trackText">
                        <div class="trackTitle">
                            <img src="../../../assets/imgs/service/cov1.png">
                            <span>主动服务</span>
                        </div>
                        <div class="trackCont">
                            为用户提供长期的全面服务是天津三博水科技有限公司的工作方针。三博公司特别注重建立完善的售后服务体系，将定期协助用户完成模型的数据更新工作，以确保用户模型的正常运行。三博的服务是长期的关怀式服务，我们称之为主动服务。
                        </div>
                    </div>
                </li>
                <li @mouseenter="activityTrack(1)" :class="[{activit : activit == 1},{activityBlock: activit == 0},{activityBlockThree: activit == 2}]">
                    <div class="coverBox">
                        <div>
                            <img src="../../../assets/imgs/service/cov2.png">
                            <p>深度培训</p>
                        </div>
                    </div>
                    <div class="trackText">
                        <div class="trackTitle">
                            <img src="../../../assets/imgs/service/cov2.png">
                            <span>深度培训</span>
                        </div>
                        <div class="trackCont">
                            培训将是天津三博服务部门的重要工作之一，将对供水企业的模型专职技术人员和普通技术人员进行全面培训。培训内容将包括模型的基础知识、模型的建立过程、模型的应用、模型的维护方法等。三博拥有专门的模型技术培训中心，培训对象不仅是已有的模型用户，也可以是任何对供水系统现代化管理感兴趣的供水企业普通技术人员。
                        </div>
                    </div>
                </li>
                <li @mouseenter="activityTrack(2)" :class="[{activit : activit == 2},{activityBlock: activit == 1}]">
                    <div class="coverBox">
                        <div>
                            <img src="../../../assets/imgs/service/cov3.png">
                            <p>应用咨询</p>
                        </div>
                    </div>
                    <div class="trackText">
                        <div class="trackTitle">
                            <img src="../../../assets/imgs/service/cov3.png">
                            <span>应用咨询</span>
                        </div>
                        <div class="trackCont">
                            天津三博水科技有限公司为已完成模型建立的供水企业提供模型应用咨询服务。服务内容涵盖供水企业管理工作的各个方面，包括供水系统的总体规划咨询、排水系统建模咨询、长距离输水管道水锤防护咨询、大型管网区块化管理咨询、供水管网漏损控制咨询、管道清洗方案咨询、非开挖管道修复技术咨询等。
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {Debounce} from "@/assets/js/public";

export default {
    name: 'List5',
    data(){
        return{
            activit:0, //当前活跃
            blk:100,
            sign:0,
            bSign:0,
        }
    },
    methods:{
        activityTrack:Debounce(function(e){
            this.activit = e;
        },300),
    }
}
</script>

<style scoped>
    #trackContainer{
        height: 300px;
        background: #efeff2;
    }
    #trackWrapper{
        width: 1120px;
        margin: 0 auto;
        position: relative;
        height: 100%;
        overflow: hidden;
    }
    #trackWrapper>li{
        width: 300px;
        height: 100%;
        cursor: default;
        float: left;
        overflow: hidden;
    }
    .trackText{
        display: none;
        height: calc(100% - 110px);
        padding: 55px 42.5px;
        text-indent: 28px;
        background: #f7f7f7;
    }
    .coverBox{
        height: 100%;
        display: flex;                      /*定位（写在父元素中）*/
        justify-content:center;           /*水平居中*/
        align-items:Center; 
    }
    .coverBox>div>img{
        width: 60px;
    }
    .coverBox>div>p{
        margin-top: 15px;
        font-size: 18px;
        font-weight: bold;
    }
    #trackWrapper>li:first-child .coverBox{
        background: url(../../../assets/imgs/service/covbg1.png);
        background-size: 100% 100%;
    }
    #trackWrapper>li:nth-child(2) .coverBox{
        background: url(../../../assets/imgs/service/covbg2.png);
        background-size: 100% 100%;
    }
    #trackWrapper>li:nth-child(3) .coverBox{
        background: url(../../../assets/imgs/service/covbg3.png);
        background-size: 100% 100%;
    }
    .trackTitle{
        width: 435px;
        display: flex;                      /*定位（写在父元素中）*/
        justify-content:center;           /*水平居中*/
        align-items:Center; 
        margin-bottom: 25px;
    }
    .trackTitle>img{
        width: 22px;
        margin-right: 10px;
    }
    .trackTitle>span{
        font-size: 16px;
        color: #0e0509;
        line-height: 22px;
    }
    .trackCont{
        width: 435px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;     /*设置行数*/
        -webkit-box-orient: vertical;
        color: #221815;
        line-height: 30px;
    }
    /* 活动样式 */

    #trackWrapper>li.activit .coverBox{
        display: none;
    }
    #trackWrapper>li.activit .trackText{
        display: block;
    }
    #trackWrapper>li.activityBlock{
        animation:myBlock .5s 1 forwards; 
        -moz-animation:myBlock .5s forwards; 
        -webkit-animation:myBlock .5s 1 forwards;
        -o-animation:myBlock .5s 1 forwards;
    }
    #trackWrapper>li.activityBlockThree{
        animation:myThree .5s 1 forwards; 
        -moz-animation:myThree .5s forwards; 
        -webkit-animation:myThree .5s 1 forwards;
        -o-animation:myThree .5s 1 forwards;
    }
    #trackWrapper>li.activit{
        animation:myActivit .5s 1 forwards; 
        -moz-animation:myActivit .5s forwards; 
        -webkit-animation:myActivit .5s 1 forwards;
        -o-animation:myActivit .5s 1 forwards;
    }
    
    @keyframes myActivit{
        0%{
            width: 225px;
        }
        100%{
            width: 520px;
        }
    }
    @keyframes myBlock{
        0%{
            width: 520px;
        }
        100%{
            width: 300px;
        }
    }
    @keyframes myThree{
        0%{
            margin-left: 210px
        }
        100%{
            margin-left: 0px
        }
    }
</style>
